import { HttpHandler } from 'msw'

import { askResetPassword } from './askResetPassword'
import { checkResetPasswordToken } from './checkResetPasswordToken'
import { getMe } from './getMe'
import { resetPassword } from './resetPassword'

export const auth: HttpHandler[] = [
    askResetPassword,
    checkResetPasswordToken,
    getMe,
    resetPassword,
]
